import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import pdf from "../assets/files/AfonsoPereiraCV.pdf";
import Footer from '../Footer';
import useReveal from '../hooks/useReveal';
import useDocumentMeta from '../hooks/useDocumentMeta';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);
  useDocumentMeta('Resume', "Download Afonso Pereira's CV — Frontend Developer experience, skills, and background.");
  const [pdfRef, pdfVisible] = useReveal();

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <>
     <div style={{ marginBottom: "160px" }}>
      <Container fluid className="resume-section">
        <Row style={{ justifyContent: "center", position: "relative" }}>
        <div>
          <a className="downloadButton" type="submit" href={pdf} download="AfonsoPereiraCV.pdf"><AiOutlineDownload style={{ height: "40px", width: "40px" }} /> DOWNLOAD CV</a>
        </div>
        </Row>

        <Row className={`resume reveal ${pdfVisible ? 'reveal--visible' : ''}`} ref={pdfRef}>
        <Document file={pdf} className="d-flex justify-content-center">
          <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.7} />
        </Document>
        </Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
        <div>
          <a className="downloadButton" type="submit" href={pdf} download="AfonsoPereiraCV.pdf"><AiOutlineDownload style={{ height: "40px", width: "40px" }} /> DOWNLOAD CV</a>
        </div>
        </Row>
      </Container>
      </div>
      <Footer />
    </>
  );
}

export default ResumeNew;